module.exports = __webpack_public_path__ + "img/no-data-Ahex.05d5956d.png";